@if(schedulerService.branchSelected()) {
  <div class="secondaryBG header-shadow p-2 md:p-4 lg:p-4 flex items-center justify-between">
    <a [href]="activeRedirect ? null : 'https://www.additionfi.com/'" [class.disabled]="activeRedirect">
      <img [src]="'images/AdditionFI.svg'" alt="AdditionFi logo"  class="h-11">
    </a>
    <div>
      @if (isKiosk && schedulerService.branchSelected().locationName !== undefined) {
        <span class="hidden md:inline font-semibold">{{schedulerService.branchSelected().locationName}}</span><span class="hidden md:inline">, {{currentTime}}</span>

      }
    </div>
  </div>
}

